import React from "react";
import { Routes, Route } from "react-router-dom";
import styled from "styled-components";
import Home from "./Home";
import About from "./About";
import Blog from "./Blog";
import Post from "./Post";
import Contact from "./Contact";
import Consulting from "./Consulting";
import Subscribe from "./Subscribe";
import Training from "./Training";
import NotFound from "./NotFound";
import NavBar from "./components/NavBar";

const AppContainer = styled.div`
  background-color: #343a40;
  height: 100%;
`;

function App() {
  return (
    <AppContainer>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/post/:slug" element={<Post />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/training" element={<Training />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppContainer>
  );
}

export default App;